import { Box } from '@mui/joy';
import { useConfigContext } from '../../contexts/config-context';
import DisclaimerBottomSheet from '../../components/chat/footer';
import Bot from '../../templates/bot';
import { useLocation } from 'react-router-dom';
import React, { Suspense } from 'react';

const Chat = React.lazy(() => import('../../components/chat'));

export default function ChatPage() {
	const { appTitle } = useConfigContext();
	const location = useLocation();

	// Get previousPathname from location state or fallback to home
	const previousPathname = location.state?.previousPathname || '/';

	return (
		<Bot
			title={appTitle}
			showMenuButton
			showBackButton={window.history.state.idx !== 0}
			footer={<DisclaimerBottomSheet testId={'disclaimer'} />}
			previousPathname={previousPathname}
		>
			<Box
				sx={{
					flex: 1,
					display: 'flex',
					flexDirection: 'column',
					minHeight: 0,
					px: 4,
				}}
			>
				<Suspense fallback={<Box>Loading...</Box>}>
					<Chat />
				</Suspense>
			</Box>
		</Bot>
	);
}
